import React from 'react';
import Typography from '@mui/material/Typography';
import { DoneValidation } from '../../interfaces/RaterNominationDetails';
import { RaterStyles } from '../../styles/rater';
import { useTranslation } from 'react-i18next';
import { visuallyHidden } from '@mui/utils';

/** Interface for Password Strength Messages */
interface DoneValidationMessagesProps {
  validation: DoneValidation;
}

export const DoneValidationMessages = ({ validation }: DoneValidationMessagesProps): React.JSX.Element => {
  const { t } = useTranslation();
  const { classes } = RaterStyles();
  const { overAllRemaining, categoriesRemaining } = validation;

  return (
    <>
      {overAllRemaining > 0 ? (
        <>
          <Typography variant="body1">{t('overallValidation')}</Typography>
          <span style={visuallyHidden}>
            {overAllRemaining} {t('overall')}
          </span>
          <ul className={classes.marginTop0}>
            <li>
              <Typography variant="body1">
                {overAllRemaining} {t('overall')}
              </Typography>
            </li>
          </ul>
        </>
      ) : null}
      {categoriesRemaining.length > 0 ? (
        <>
          <Typography variant="body1">
            {overAllRemaining < 1 ? t('overallValidation') : t('raterCategoryValidation')}
          </Typography>
          {categoriesRemaining.map((rater) => (
            <React.Fragment key={rater.roleName}>
              <span style={visuallyHidden}>
                {rater.remainingCount} {rater.roleName}
              </span>
              <ul className={classes.noMargin}>
                <li>
                  <Typography variant="body1">
                    {rater.remainingCount} {rater.roleName}
                  </Typography>
                </li>
              </ul>
            </React.Fragment>
          ))}
        </>
      ) : null}
    </>
  );
};
